(function () {
  'use strict';

  angular
    .module('app')
    .factory('serverCalls', ['$http', '$q', 'ServerData', serverCalls]);

  function serverCalls($http, $q, ServerData) {

    function getFanData(options) {
      var deferred = $q.defer(),
        req = {
          method: 'POST',
          url: ServerData.URL + ':' + ServerData.PORT + '/api/v1/priv/findByUIDAndTplName',
          data: options
        };

      $http(req).then(function (response) {
        deferred.resolve(response.data);
      }, function (err) {
        deferred.reject({message: 'ERR in sendReport: ' + JSON.stringify(err)});
      });

      return deferred.promise;
    }

    function getSavings(options) {
      var deferred = $q.defer(),
        req = {
          method: 'POST',
          url: ServerData.URL + ':' + ServerData.PORT + '/api/v1/public/getDataloggerMonthly',
          data: options
        };

      $http(req).then(function (response) {
        deferred.resolve(response.data);
      }, function (err) {
        deferred.reject({message: 'ERR in sendReport: ' + JSON.stringify(err)});
      });

      return deferred.promise;
    }

    return {
      getFanData: getFanData,
      getSavings: getSavings
    };

  }

}());
